export var a1 =  
[
'Africa/Asmara',
'Africa/Abidjan',
'Africa/Tripoli',
'Africa/Cairo',
'America/Argentina/Catamarca',
'America/Adak',
'America/Argentina/Buenos_Aires',
'America/Argentina/Catamarca',
'America/Atikokan',
'America/Argentina/Cordoba',
'America/Tijuana',
'America/Indiana/Indianapolis',
'America/Indiana/Indianapolis',
'America/Argentina/Jujuy',
'America/Indiana/Knox',
'America/Kentucky/Louisville',
'America/Argentina/Mendoza',
'America/Toronto',
'America/Rio_Branco',
'America/Argentina/Cordoba',
'America/Tijuana',
'America/Denver',
'America/Port_of_Spain',
'America/Anchorage',
'America/Adak',
'America/Phoenix',
'America/Chicago',
'America/New_York',
'America/Indiana/Indianapolis',
'America/Indiana/Knox',
'America/Detroit',
'America/Denver',
'America/Los_Angeles',
'America/Rio_Branco',
'America/Noronha',
'America/Sao_Paulo',
'America/Manaus',
'America/Halifax',
'America/Winnipeg',
'America/Toronto',
'America/Edmonton',
'America/St_Johns',
'America/Vancouver',
'America/Regina',
'America/Whitehorse',
'America/Santiago',
'America/Havana',
'America/Tijuana',
'America/Mazatlan',
'America/Mexico_City',
'America/Denver',
'America/Jamaica',
'Asia/Ashgabat',
'Asia/Kolkata',
'Asia/Shanghai',
'Asia/Dhaka',
'Asia/Shanghai',
'Asia/Urumqi',
'Asia/Kathmandu',
'Asia/Macau',
'Asia/Yangon',
'Asia/Ho_Chi_Minh',
'Asia/Jerusalem',
'Asia/Thimphu',
'Asia/Makassar',
'Asia/Ulaanbaatar',
'Asia/Hong_Kong',
'Asia/Shanghai',
'Asia/Taipei',
'Asia/Seoul',
'Asia/Singapore',
'Asia/Tehran',
'Asia/Jerusalem',
'Asia/Tokyo',
'Australia/Sydney',
'Australia/Sydney',
'Australia/Lord_Howe',
'Australia/Darwin',
'Australia/Sydney',
'Australia/Brisbane',
'Australia/Adelaide',
'Australia/Hobart',
'Australia/Melbourne',
'Australia/Perth',
'Australia/Broken_Hill',
'Europe/Dublin',
'Europe/Chisinau',
'Europe/Istanbul',
'Europe/Oslo',
'Europe/London',
'Europe/Moscow',
'Europe/Warsaw',
'Europe/Lisbon',
'Atlantic/Reykjavik',
'Atlantic/Faroe',
'Pacific/Kwajalein',
'Pacific/Auckland',
'Pacific/Chatham',
'Pacific/Honolulu',
'Pacific/Pohnpei',
'Pacific/Pago_Pago',
'Pacific/Chuuk',
'Pacific/Easter',
];

